import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

@Entity({one: "subscription", many: "subscriptions"})
export default class Subscription {

	@Field()
	public id: ID;

	@Field()
	public completion: any;

	@Field()
	public completedOn?: string;

	@Field()
	public score?: number;

	@Field()
	public maxScore?: number;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

}



// WEBPACK FOOTER //
// ./src/panels/programStatus/entities/Subscription.ts